export default __webpack_public_path__ + "static/media/r-bs.d7a792fb.png";